function isVisible(el) {
  if (!el) return false;
  const style = window.getComputedStyle(el);
  return (
    style.display !== "none" &&
    style.visibility !== "hidden" &&
    style.opacity !== "0"
  );
}

export function searchBar() {
  const loadMore = ".load-more";
  const searchBarId = "#search-bar";
  const searchbarEl = document.querySelector(searchBarId);

  //open
  document.getElementById("activate-search").addEventListener("click", () => {
    searchbarEl.classList.add("open"); // open
  });

  //on click outside the search bar, close it
  document.addEventListener("click", (event) => {
    const target = event.target;
    const searchBarVisible = isVisible(searchbarEl);

    const buttonActivate = target.closest("#activate-search");
    const outside = !target.closest(searchBarId) && !target.closest(loadMore);
    let closeButton = target.closest(".close") && target.closest(searchBarId);

    if ((outside || closeButton) && !buttonActivate && searchBarVisible) {
      searchbarEl.classList.remove("open"); //close
    }
  });

  document.addEventListener("keyup", (evt) => {
    if (evt.keyCode == 27) {
      searchbarEl.classList.remove("open"); //close
    }
  });
}
